import { ROUTES } from "./routesConstants";

export const STEPS = {
  // shared steps
  HOMEPAGE: "HOMEPAGE",
  PROJECT_INFORMATION: "PROJECT_INFORMATION",
  TRAFFIC_VOLUMES: "TRAFFIC_VOLUMES",
  DESIGN_SELECTION: "DESIGN_SELECTION",

  // life cycle cost steps
  GLOBAL_INPUT_DATA: "GLOBAL_INPUT_DATA",
  DELAY: "DELAY",
  COST_PARAMETERS: "COST_PARAMETERS",
  GLOBAL_SAFETY_DATA: "GLOBAL_SAFETY_DATA",
  SAFETY: "SAFETY",
  OUTPUTS: "OUTPUTS",

  // cap x steps
  CAPACITY_ANALYSIS: "CAPACITY_ANALYSIS",
};

export const LIFE_CYCLE_COST_STEPS_ORDER = [
  STEPS.HOMEPAGE,
  STEPS.PROJECT_INFORMATION,
  STEPS.GLOBAL_INPUT_DATA,
  STEPS.TRAFFIC_VOLUMES,
  STEPS.DESIGN_SELECTION,
  STEPS.DELAY,
  STEPS.COST_PARAMETERS,
  STEPS.GLOBAL_SAFETY_DATA,
  STEPS.SAFETY,
  STEPS.OUTPUTS,
];

export const CAP_X_STEPS_ORDER = [
  STEPS.HOMEPAGE,
  STEPS.PROJECT_INFORMATION,
  STEPS.TRAFFIC_VOLUMES,
  STEPS.DESIGN_SELECTION,
  STEPS.CAPACITY_ANALYSIS,
];

// maps all live routes in the app to one of the "steps"
export const ROUTES_TO_STEPS = {
  // shared steps
  [ROUTES.HOMEPAGE]: STEPS.HOMEPAGE,
  [ROUTES.PROJECT_INFORMATION]: STEPS.PROJECT_INFORMATION,
  [ROUTES.TRAFFIC_VOLUMES]: STEPS.TRAFFIC_VOLUMES,
  [ROUTES.TRAFFIC_VOLUMES_DEFAULTS]: STEPS.TRAFFIC_VOLUMES,
  [ROUTES.DESIGN_SELECTION]: STEPS.DESIGN_SELECTION,

  // life cycle cost steps
  [ROUTES.GLOBAL_INPUT_DATA]: STEPS.GLOBAL_INPUT_DATA,
  [ROUTES.DELAY]: STEPS.DELAY,
  [ROUTES.COST_PARAMETERS]: STEPS.COST_PARAMETERS,
  [ROUTES.COST_PARAMETERS_DEFAULTS]: STEPS.COST_PARAMETERS,
  [ROUTES.COST_PARAMETERS_OPERATIONS_MAINTENANCE_DEFAULTS]:
    STEPS.COST_PARAMETERS,
  [ROUTES.GLOBAL_SAFETY_DATA]: STEPS.GLOBAL_SAFETY_DATA,
  [ROUTES.SAFETY]: STEPS.SAFETY,
  [ROUTES.SAFETY_DEFAULTS]: STEPS.SAFETY,
  [ROUTES.OUTPUTS]: STEPS.OUTPUTS,

  // cap x steps
  [ROUTES.CAPACITY_ANALYSIS]: STEPS.CAPACITY_ANALYSIS,
};

export const LIFE_CYCLE_COST_STEPPER_STEPS_ORDER = [
  {
    label: "Project Information",
    id: STEPS.PROJECT_INFORMATION,
  },
  {
    label: "Global Input Data",
    id: STEPS.GLOBAL_INPUT_DATA,
  },
  {
    label: "Traffic Volumes",
    id: STEPS.TRAFFIC_VOLUMES,
  },
  {
    label: "Design Selection",
    id: STEPS.DESIGN_SELECTION,
  },
  {
    label: "Delay",
    id: STEPS.DELAY,
  },
  {
    label: "Cost Parameters",
    id: STEPS.COST_PARAMETERS,
  },
  {
    label: "Global Safety Data",
    id: STEPS.GLOBAL_SAFETY_DATA,
  },
  {
    label: "Safety",
    id: STEPS.SAFETY,
  },
  {
    label: "Outputs",
    id: STEPS.OUTPUTS,
  },
];

export const CAP_X_STEPPER_STEPS_ORDER = [
  {
    label: "Project Information",
    id: STEPS.PROJECT_INFORMATION,
  },
  {
    label: "Traffic Volumes",
    id: STEPS.TRAFFIC_VOLUMES,
  },
  {
    label: "Design Selection",
    id: STEPS.DESIGN_SELECTION,
  },
  {
    label: "Capacity Analysis",
    id: STEPS.CAPACITY_ANALYSIS,
  },
];
